// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1felH","legacyBtn":"MutateMid_legacyBtn__3GTIH"};